import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const NavBar = ({ onBuy }) => {
  const { t, lang, toggle } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const goHome = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  const handleBuy = () => {
    if (onBuy) return onBuy();
    if (location.pathname === "/") {
      document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
      }, 150);
    }
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-40 border-b transition-colors ${
        scrolled ? "bg-ink/95 backdrop-blur border-[#222]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <a href="/" onClick={goHome} className="flex items-center gap-2" data-testid="nav-logo">
          <span className="inline-block w-3 h-3 bg-wood" />
          <span className="font-display text-2xl tracking-brutal">CRVD</span>
        </a>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            data-testid="language-toggle"
            aria-label={`Switch language, current: ${lang.toUpperCase()}`}
            className="flex items-center gap-1.5 font-mono text-[11px] tracking-tech border border-[#333] px-3 py-2 hover:border-wood transition-colors group"
          >
            <span className={lang === "en" ? "text-wood" : "text-bone/40 group-hover:text-bone"}>EN</span>
            <span className="text-bone/30">/</span>
            <span className={lang === "it" ? "text-wood" : "text-bone/40 group-hover:text-bone"}>IT</span>
          </button>
          <button
            onClick={handleBuy}
            data-testid="nav-buy-button"
            className="font-mono text-[11px] tracking-tech bg-wood text-ink px-4 py-2 hover:bg-bone transition-colors"
          >
            {t("nav.buy")}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
